"use client";

import { SearchPageFooterPlaceholder } from "@faire/retailer-visitor-shared/app/(app)/retailer/[locale]/(pagesWithModal)/(defaultHeader)/search/loggedInSearchLoadingSkeleton";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { MaybeWhenVisibilityIsImminent } from "@faire/retailer-visitor-shared/views/brand/__internal__/MaybeWhenVisibilityIsImminent";
import { LazySearchPageFooterBase } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageFooter/index";
import { useSearchPageNonPrimaryContentDeferRender } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPagePerformanceTrackingWrapper";
import { useTraceComponentRender } from "@faire/web--source/common/tracing/useTraceComponentRender";
import React, { Suspense } from "react";

export const SearchPageFooter = () => {
  useTraceComponentRender("LazySearchPageFooter");

  useSearchPageNonPrimaryContentDeferRender();
  const shouldDeferRender = useIsLoggedInRetailer();

  // When we are deferring the render, we don't need to wrap the component
  // WhenVisibilityIsImminent as it just causes extra waiting when CUJ
  // content is already done loading.
  return (
    <MaybeWhenVisibilityIsImminent
      customizePlaceholder={<SearchPageFooterPlaceholder />}
      shouldWrap={!shouldDeferRender}
    >
      <Suspense>
        <LazySearchPageFooterBase />
      </Suspense>
    </MaybeWhenVisibilityIsImminent>
  );
};
